import { render, staticRenderFns } from "./CommentCounter.vue?vue&type=template&id=c5051924&scoped=true&"
import script from "./CommentCounter.vue?vue&type=script&lang=js&"
export * from "./CommentCounter.vue?vue&type=script&lang=js&"
import style0 from "./CommentCounter.vue?vue&type=style&index=0&id=c5051924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5051924",
  null
  
)

export default component.exports